import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-elevation");
import { style as _style } from '@vanilla-extract/css';
import { tokens } from '@paypalcorp/pp-react-theme';
import { rgba } from '@paypalcorp/pp-react-utils';
function style(rule, debugId) {
  return [_style(rule, debugId), rule];
}
const remBase = 16;
const getOffsetX = level => `calc(((${tokens.elevation.horizontalOffsetRatio} * ${level})/${remBase}) * 1rem)`;
const getOffsetY = level => `calc(((${tokens.elevation.verticalOffsetRatio} * ${level - 1})/${remBase}) * 1rem)`;
const getAboveOffsetY = level => `calc(((${tokens.elevation.verticalOffsetRatio} * ${-(level - 1)})/${remBase}) * 1rem)`;
const getBlur = level => {
  const curveAndSlopValue = `calc(((${level} * ${level} * ${tokens.elevation.blurCurve} + ${level} * ${tokens.elevation.blurSlope})/${remBase}) * 1rem)`;
  return `calc(${curveAndSlopValue} + ${tokens.elevation.blurBase})`;
};
const colorOpacity = (level = 1) => `calc(${level} * ${tokens.elevation.opacity}*100%)`;
const color = rgba(tokens.color.structure.shadow, colorOpacity());
const backgroundColor = level => rgba(tokens.color.background.surface, colorOpacity(level));
const shadowProps = level => `${getOffsetX(level)} ${getOffsetY(level)} ${getBlur(level)} ${color}`;
const backgroundImage = level => `linear-gradient(${backgroundColor(level)}, ${backgroundColor(level)})`;
export const [level1, level1Styles] = style({
  boxShadow: shadowProps(1),
  backgroundImage: backgroundImage(1)
}, 'elevation_level1');
export const [level2, level2Styles] = style({
  boxShadow: shadowProps(2),
  backgroundImage: backgroundImage(2)
}, 'elevation_level2');
export const [level3, level3Styles] = style({
  boxShadow: shadowProps(3),
  backgroundImage: backgroundImage(3)
}, 'elevation_level3');
export const [filterLevel1, filterLevel1Styles] = style({
  filter: `drop-shadow(${shadowProps(1)})`
}, 'drop_shadow1');
export const [filterLevel2, filterLevel2Styles] = style({
  filter: `drop-shadow(${shadowProps(2)})`
}, 'drop_shadow2');
export const [filterLevel3, filterLevel3Styles] = style({
  filter: `drop-shadow(${shadowProps(3)})`
}, 'drop_shadow3');
export const [level1Horizontal, level1HorizontalStyles] = style({
  boxShadow: `0 0 ${getBlur(0.33)} ${color}`
}, 'fixed_elevation');
export const [level3Above, level3AboveStyles] = style({
  boxShadow: `${getOffsetX(3)} ${getAboveOffsetY(3)} ${getBlur(3)} ${color}`,
  backgroundImage: backgroundImage(3),
  transform: 'translateZ(0)'
}, 'elevation_level3_above');
__vanilla_filescope__.endFileScope();
